<script setup>
// Módulo "Atendimentos" (agendamento) — orquestrador: header + barra de abas + componente da aba.
// Cada aba é um componente próprio em ./appointments (boas práticas, sem monolito).
import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { markRaw } from 'vue';
import { useI18n } from 'vue-i18n';
import AgendaTab from './appointments/AgendaTab.vue';
import PatientsTab from './appointments/PatientsTab.vue';
import PractitionersTab from './appointments/PractitionersTab.vue';
import ServicesTab from './appointments/ServicesTab.vue';
import HealthPlansTab from './appointments/HealthPlansTab.vue';
import ReportsTab from './appointments/ReportsTab.vue';
import { ICON } from './appointments/constants';

const route = useRoute();
const accountId = route.params.accountId;
const { t } = useI18n();

const TABS = [
  {
    id: 'agenda',
    labelKey: 'ATENDIMENTOS.tabs.agenda',
    icon: ICON.calendar,
    comp: markRaw(AgendaTab),
  },
  {
    id: 'clientes',
    labelKey: 'ATENDIMENTOS.tabs.pacientes',
    icon: ICON.users,
    comp: markRaw(PatientsTab),
  },
  {
    id: 'profissionais',
    labelKey: 'ATENDIMENTOS.tabs.profissionais',
    icon: ICON.users,
    comp: markRaw(PractitionersTab),
  },
  {
    id: 'servicos',
    labelKey: 'ATENDIMENTOS.tabs.servicos',
    icon: ICON.briefcase,
    comp: markRaw(ServicesTab),
  },
  {
    id: 'parceiros',
    labelKey: 'ATENDIMENTOS.tabs.convenios',
    icon: ICON.shield,
    comp: markRaw(HealthPlansTab),
  },
  {
    id: 'relatorios',
    labelKey: 'ATENDIMENTOS.tabs.relatorios',
    icon: ICON.chart,
    comp: markRaw(ReportsTab),
  },
];
const tab = ref('agenda');
const current = computed(() => TABS.find(item => item.id === tab.value));
</script>

<template>
  <div class="flex flex-col w-full h-full overflow-hidden bg-n-background">
    <header class="px-6 py-3 bg-n-background border-b shrink-0 border-n-weak">
      <div class="flex items-center gap-3 mb-3">
        <span
          class="flex items-center justify-center w-8 h-8 text-white bg-n-brand rounded-lg"
        >
          <svg
            class="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              :d="ICON.calendar[0]"
            />
          </svg>
        </span>
        <h1 class="text-heading-1 text-n-slate-12">
          {{ t('ATENDIMENTOS.title') }}
        </h1>
      </div>
      <div class="flex gap-1 overflow-x-auto">
        <button
          v-for="tb in TABS"
          :key="tb.id"
          class="inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-lg whitespace-nowrap"
          :class="
            tab === tb.id
              ? 'bg-n-blue-3 text-n-blue-11'
              : 'text-n-slate-11 hover:bg-n-alpha-1'
          "
          @click="tab = tb.id"
        >
          <svg
            class="w-4 h-4"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              :d="tb.icon[0]"
            />
          </svg>
          {{ t(tb.labelKey) }}
        </button>
      </div>
    </header>

    <component
      :is="current.comp"
      :account-id="accountId"
      class="flex-1 min-h-0 overflow-auto"
    />
  </div>
</template>
